import { adminHttpClient } from '../../commons/adminHttpClient'

export interface CannedMessage {
  id?: string
  title: string
  message: string
  type: CannedMessageType
}

export enum CannedMessageType {
  Expense = 0,
  Premium = 1,
}

export const getForCannedMessagesView = () => {
  return adminHttpClient.get('DocReview/CannedMessages')
}
